import mainMenu from '@/config/menus/main'
import invoicesMenu from '@/config/menus/invoices'
import receivedInvoicesMenu from '@/config/menus/receivedInvoices'
import companiesMenu from '@/config/menus/companies'
import certificatesMenu from '@/config/menus/certificates'
import replacecertificate from '@/config/menus/replacecertificate'
import configUsersMenu from '@/config/menus/configurationsUsers'
import invoicesNew from '@/config/menus/invoicesNew'
import verifactu from '@/config/menus/verifactu'
import configurationsGroups from '@/config/menus/configurationsGroups'
import configurationsGrouping from '@/config/menus/configurationsGrouping'
import configurationsGroupingMain from '@/config/menus/configurationsGroupingMain'
import configurationsRules from '@/config/menus/configurationsRules'
import configurationsTrashGroups from '@/config/menus/configurationsTrashGroups'
import configurationsClients from '@/config/menus/configurationsClients'
import configurationsWebhook from '@/config/menus/configurationsWebHook'
import configurationsWebhookAdmin from '@/config/menus/configurationsWebHookAdmin'
import configurationsSociedad from '@/config/menus/configurationsSociedad'
import configurationsImpuestos from '@/config/menus/configurationsImpuestos'
import configurationsProducts from '@/config/menus/configurationsProducts'
import configurationsTrashImpuestos from '@/config/menus/configurationsTrashImpuestos'
import configurationsTrashProducts from '@/config/menus/configurationsTrashProducts'
import configurationsAdministrativeCenter from '@/config/menus/configurationsAdministrativeCenter'
import configurationsSedes from '@/config/menus/configurationsSedes'
import configurationsBankAccounts from '@/config/menus/configurationsBankAccounts'
import configurationsDistributors from '@/config/menus/configurationsDistributors'
import configurationsTrashInvoices from '@/config/menus/configurationsTrashInvoices'
import configurationsTrashReceivedInvoices from '@/config/menus/configurationsTrashReceivedInvoices'
import configurationsTrashCertificates from '@/config/menus/configurationsTrashCertificates'
import configurationsTrashCompanies from '@/config/menus/configurationsTrashCompanies'
import configurationsTrashUsers from '@/config/menus/configurationsTrashUsers'
import configurationsTrashSociedad from '@/config/menus/configurationsTrashSociedad'
import { getEstadosFacturas } from '@/services/app/getEstadosFacturas'

const state = () => ({
  gettingNotificationsMenu: false,
})

const getters = {
  mainMenu: () => {
    const main = mainMenu()
    return main
  },
  secondaryMenu: (state) => (menu, params) => {
    switch (menu) {
      case 'invoicesissued':
        return invoicesMenu(params)
      case 'invoicesreceived':
        return receivedInvoicesMenu(params)
      case 'verifactu':
        return verifactu(params)
      case 'companies':
        return companiesMenu(params)
      case 'certificates':
        return certificatesMenu(params)
      case 'replacecertificate':
        return replacecertificate(params)
      case 'configurations/users':
        return configUsersMenu(params)
      case 'configurations/groups':
        return configurationsGroups(params)
      case 'configurations/grouping':
        return configurationsGrouping(params)
      case 'configurations/grouping/main':
        return configurationsGroupingMain(params)
      case 'configurations/rules':
        return configurationsRules(params)
      case 'masters/society':
        return configurationsSociedad(params)
      case 'masters/impuestos':
        return configurationsImpuestos(params)
      case 'masters/products':
        return configurationsProducts(params)
      case 'configurations/trash/impuestos':
        return configurationsTrashImpuestos(params)
      case 'masters/administrativecenters':
        return configurationsAdministrativeCenter(params)
      case 'masters/locations': 
        return configurationsSedes(params)
      case 'masters/society/locations/bankaccounts': 
        return configurationsBankAccounts(params)
      case 'configurations/clients':
        return configurationsClients(params)
      case 'configurations/clients/webhooks':
        return configurationsWebhook(params)
      case 'configurations/webhooks':
        return configurationsWebhookAdmin(params)
      case 'configurations/distributors':
        return configurationsDistributors(params)
      case 'configurations/trash/certificates':
        return configurationsTrashCertificates(params)
      case 'configurations/trash/companies':
        return configurationsTrashCompanies(params)
      case 'configurations/trash/invoicesissued':
        return configurationsTrashInvoices(params)
      case 'configurations/trash/invoicesreceived':
        return configurationsTrashReceivedInvoices(params)
      case 'configurations/trash/users':
        return configurationsTrashUsers(params)
      case 'configurations/trash/society':
        return configurationsTrashSociedad(params)
      case 'configurations/trash/products':
        return configurationsTrashProducts(params)
      case 'configurations/trash/groups':
        return configurationsTrashGroups(params)
      case 'invoices/new':
        return invoicesNew()
      default:
        return []
    }
  }
}

const mutations = {
  setMainMenu (state, mainMenu) {
    state.mainMenu = mainMenu
  },
  get_menu_request (state) {
    state.gettingNotificationsMenu = true
  },
  get_menu_success (state, tiposAccionesFacturas) {
    state.TiposAccionesFacturas = tiposAccionesFacturas
    state.gettingNotificationsMenu = false
  },
  get_menu_error (state) {
    state.gettingNotificationsMenu = false
  }
}

const actions = {
  getEstadosFacturasNav ({ commit }, estado) {
    return new Promise((resolve, reject) => {
      commit('get_menu_request')
      getEstadosFacturas().then(response => {
        if (response.blnError) {
          commit('get_menu_error')
          return Promise.reject(response)
        }
        commit('get_menu_success', response.respuesta)
        resolve(response)
      })
        .catch(err => {
          commit('get_menu_error')
          reject(err)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
